import { RefreshCw } from 'lucide-react'
import { useEffect, useRef, useState } from 'react'
import { useApp } from '../context/AppContext'
import { api } from '../lib/api'
import type { Report } from '../types'

export function LiveReportSync({ onUpdated }: { onUpdated: (items: Report[]) => void }) {
  const { authenticated, demoMode } = useApp()
  const lock = useRef(false)
  const [busy, setBusy] = useState(false)
  const [message, setMessage] = useState('')
  const [lastSuccess, setLastSuccess] = useState('')
  useEffect(() => {
    if (!authenticated || demoMode) return
    let active = true
    void api.reportsAdmin.syncStatus().then(state => {
      if (!active) return
      if (state.lastSuccess) setLastSuccess(new Date(state.lastSuccess.finished_at).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }))
      if (!lock.current && state.current?.status === 'running') setMessage('后台任务正在执行；点击采集可继续查看进度')
      if (!lock.current && state.current?.status === 'failed') setMessage(`最近采集未成功：${state.current.error_message}`)
    }).catch(() => {})
    return () => { active = false }
  }, [authenticated, demoMode])

  async function collect() {
    if (lock.current) return
    lock.current = true
    setBusy(true)
    setMessage('')
    try {
      const result = await api.reportsAdmin.sync(setMessage)
      if(result.finishedAt)setLastSuccess(new Date(result.finishedAt).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }))
      try {
        onUpdated(await api.reports())
        setMessage(`采集完成：读取 ${result.count} 条，已去重保留历史`)
      } catch {
        setMessage('采集已完成，但列表刷新失败，请刷新页面查看')
      }
    } catch (error) {
      setMessage(`采集失败，原内容保留：${error instanceof Error ? error.message : '请稍后重试'}`)
    } finally {
      lock.current = false
      setBusy(false)
    }
  }

  if (!authenticated || demoMode) return null
  return <div className="live-report-admin" data-busy={busy}>
    {message && <div className="live-report-sync-result" role="status">{message}<button type="button" aria-label="关闭采集提示" onClick={() => setMessage('')}>×</button></div>}
    <button className="live-report-sync" type="button" disabled={busy} onClick={() => void collect()} title={lastSuccess ? `最近成功（北京时间）：${lastSuccess}` : '手动采集实时线报'}><RefreshCw size={13}/>{busy ? '后台采集中…' : '采集'}</button>
  </div>
}
